import Dialog from '@mui/material/Dialog'
import { styled } from '@mui/material/styles'
import type { FC } from 'react'

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    minWidth: 350
  },
  '& .MuiDialogTitle-root': {
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.action.selected,
    color: 'white'
  },
  '& .MuiDialogContent-root': {
    paddingTop: '24px !important'
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(2)
  }
}))

const CustomDialog: FC<{
  open: boolean
  handleClose: () => void
  children: React.ReactNode
}> = ({ open, handleClose, children }) => {
  return (
    <StyledDialog open={open} onClose={handleClose}>
      {children}
    </StyledDialog>
  )
}
export default CustomDialog
